export const CFeaturesFlagConfigTypes = {
    FIREBASE: 'FIREBASE',
    FILES_CONFIG: 'FILES_CONFIG',
} as const;